export function occupationPercentFromCounts(occupied: string, total: string): number {
  const t = Number(total);
  if (!t || Number.isNaN(t)) return 0;
  const o = Number(occupied);
  if (Number.isNaN(o)) return 0;
  return (o / t) * 100;
}
